export const Footer: React.FC = () => (
  <div className="font-lato text-1214 text-regentGrey text-center px-12 py-4">
    Analytics presented here are based on timestamps generated by a computer vision algorithm and
    are reviewed by our data specialists for accuracy.
  </div>
);
